import { HeroContent } from './types';

export const css = `
  .hero-section {
    background-image:
      radial-gradient(circle at 100% 0, var(--c-secondary-1) 0%, var(--c-secondary-1) calc(50% - 1px), transparent 50%),
      linear-gradient(135deg, var(--c-secondary-0) 0%, var(--c-secondary-1) 100%);

    & .cta-primary {
      background: var(--c-primary-6);
      color: var(--c-neutral-0);

      &:hover {
        background: var(--c-primary-7);
        color: var(--c-neutral-0);
      }
    }

    & .cta-secondary {
      color: var(--c-primary-6);

      &:hover {
        color: var(--c-primary-7);
      }
    }
  }
`;

export function View({ data }: { data: HeroContent }) {
  return (
    <section class="hero-section relative py-40">
      <div class="max-w-7xl mx-auto px-8">
        <div class="max-w-xl relative z-10">
          <h1 class="text-5xl md:text-6xl font-bold mb-8">{data.title}</h1>
          <p class="text-xl mb-10 opacity-90">{data.subtitle}</p>
          <div class="flex flex-col sm:flex-row gap-5 text-base">
            <a
              href={data.cta.primary.href}
              class="cta-primary inline-flex items-center gap-3 uppercase tracking-wider font-medium px-9 py-4.5 rounded-lg shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <span>{data.cta.primary.icon}</span> {data.cta.primary.text}
            </a>
            <a
              href={data.cta.secondary.href}
              class="cta-secondary inline-flex items-center gap-3 font-medium px-9 py-4 rounded-lg border-2 hover:-translate-y-0.5 transition-all duration-300 border-current"
            >
              <span>{data.cta.secondary.icon}</span> {data.cta.secondary.text}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
